import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";

const FALLBACK = { city: "Hyderabad", pincode: "500072" };

export const GeoLocation = () => {
    const [loc, setLoc] = useState(FALLBACK);
    const [live, setLive] = useState(false);

    useEffect(() => {
        if (!navigator.geolocation) return undefined;
        let cancelled = false;
        navigator.geolocation.getCurrentPosition(
            async (pos) => {
                try {
                    const { latitude, longitude } = pos.coords;
                    const res = await fetch(
                        `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
                    );
                    const data = await res.json();
                    if (cancelled) return;
                    const a = data.address || {};
                    const city =
                        a.city || a.town || a.village || a.suburb || a.state_district || FALLBACK.city;
                    const pincode = a.postcode || FALLBACK.pincode;
                    setLoc({ city, pincode });
                    setLive(true);
                } catch {
                    /* keep fallback */
                }
            },
            () => {},
            { timeout: 8000 }
        );
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <span
            data-testid="header-location"
            className="flex items-center gap-1.5 font-mono2 text-[10px] font-normal uppercase tracking-widest text-slate-400 sm:text-xs"
        >
            <MapPin size={13} className={live ? "text-teal-600" : "text-red-500"} />
            <span className="hidden xs:inline sm:inline">
                {loc.city} · {loc.pincode}
            </span>
        </span>
    );
};
